module.exports = __webpack_public_path__ + "static/media/logo-PCI.baea413b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-logos/logo-PCI.jpg
// module id = 2329
// module chunks = 17